<!--
 * @Author: wangxiaoheng
 * @Date: 2022-12-08 14:52:29
 * @LastEditors: wangxiaoheng
 * @LastEditTime: 2023-02-27 17:05:21
 * @FilePath: \megagame_web\src\components\login\HeadWrap.vue
 * @Description: 
 * 
 * 
-->
<template>
  <div class="head-wrap">
    <div class="logo-wrap" :style="wrapStyle">
      <div class="greeting" :style="{ marginTop: `${top}px` }">
        <img src="@/assets/images/login/logo.png" alt="" srcset="" />
        <div v-if="title">欢迎登录</div>
        <p v-if="title">{{ greeting }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    styles: {
      type: String,
      default: ""
    },
    top: {
      type: String,
      default: "164"
    }
  },
  computed: {
    greeting: function () {
      // return `全国中小学生绘画书法作品比赛${this.title}`;
      // return `全国中小学生绘画书法作品比赛平台`;
      return `全国中小学生竞赛展演活动智慧服务平台`;
    },
    wrapStyle: function () {
      return this.styles;
    }
  }
};
</script>

<style lang="scss" scoped>
.head-wrap {
  .logo-wrap {
    // min-height: 304px;
    width: 375px;
    background: url("../../assets/images/login/login-back.png");
    background-size: 375px 304px;
    background-position: 0 0;
    background-repeat: no-repeat;
    margin: 0 auto;
    overflow: hidden;
    .greeting {
      color: #fff;
      min-height: 140px;
      margin-top: 164px;
      border-radius: 16px;
      background-color: #fff;
      img {
        width: 54px;
        height: 54px;
        margin-top: 40px;
      }
      div {
        font-size: 18px;
        font-weight: 700;
        line-height: 30px;
        color: #333;
        font-weight: bold;
        margin-top: 21px;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #999999;
        margin-top: 8px;
      }
    }
  }
}
</style>
